import { render } from "./bullet.vue?vue&type=template&id=0c637c67"
import script from "./bullet.vue?vue&type=script&lang=js"
export * from "./bullet.vue?vue&type=script&lang=js"

import "./bullet.vue?vue&type=style&index=0&id=0c637c67&lang=css"

import exportComponent from "C:\\Users\\Administrator.DESKTOP-7G84OHA\\Desktop\\dduh-active-webh5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__